import React, { Component } from 'react';

class NavAction extends Component {


  onAction() {
      if(this.props.action)
        this.props.action();
  }

  render() {
    return (
      <button className="navAction" onClick={this.onAction.bind(this)}>
        {this.props.children}
      </button>
    );
  }

}

export default NavAction;



// WEBPACK FOOTER //
// ./src/components/ui/nav/NavAction.js